import { ArrowRightIcon } from "@heroicons/react/outline";

export const TerminationReasonsJobInfo = ({ issueCount, onViewDetails }: { issueCount: number; onViewDetails?: () => void }) => {
  return (
    <div className="col-span-7 grid grid-cols-subgrid border bg-error-50 border-error-200 rounded mb-4">
      <div className="col-span-6 p-4 flex items-center">
        <p className="font-medium text-sm text-error-700 min-w-0">
          {issueCount} {issueCount === 1 ? 'issue' : 'issues'} detected across your URLs and configuration
        </p>
      </div>
      <div className="col-span-1 py-4 px-1 flex items-center">
        {onViewDetails && (
          <button
            onClick={onViewDetails}
            className="flex items-center justify-center gap-1 rounded"
          >
            <span className="font-medium text-sm text-neutral-900 whitespace-nowrap">View details</span>
            <ArrowRightIcon className="w-4 h-4 text-neutral-900" />
          </button>
        )}
      </div>
    </div>
  );
}
